type ICD10ListProps = {
  data: unknown[] | null | undefined;
};

export function ICD10List({ data }: ICD10ListProps) {
  if (!data) return <></>;

  return (
    <>
      {data.map((diagnosis, index) => {
        const d = diagnosis as { id?: string | number; value?: string };

        return (
          <li className="ICD10-items" key={d.id ?? index}>
            {d.value}
          </li>
        );
      })}
    </>
  );
}
